module.exports = __webpack_public_path__ + "img/headerDownArrow.6a106179.svg";